import React from 'react'

export default function Socail() {
    return (
        <ul className="home-social mt-5 hide-on-med-and-down">
            <li className="mb-3 "> 
                <a className="white-text" href="#0">
                <i className="fa fa-facebook f-xs" aria-hidden="true" ></i>
                <span className="white-text d-none">Facebook</span>
                </a>
            </li>
            <li className="mb-3 "> 
                <a className="white-text" href="#0">
                <i className="fa fa-twitter f-xs" aria-hidden="true"></i>
                <span className="white-text d-none">Twiiter</span></a>
            </li>
            <li className="mb-3 "> 
                <a className="white-text" href="#0"><i className="fa fa-instagram f-xs" aria-hidden="true"></i>
                <span className="white-text d-none">Instagram</span></a>
            </li>
            <li className="mb-3 "> 
                <a className="white-text" href="#0"><i className="fa fa-behance f-xs" aria-hidden="true"></i>
                <span className="white-text d-none">Behance</span></a>
            </li>
            <li className="mb-3 ">
                <a className="white-text" href="#0">
                <i className="fa fa-dribbble f-xs" aria-hidden="true"></i>
                <span className="white-text d-none">Dribbble</span></a>
            </li>
        </ul>
    )
}
